import React from 'react';
import classNames from 'classnames';

import './bubble.scss';

export enum BubbleType {
  Wide,
  Right
}
interface BubbleProps {
  children?: any;
  type?: BubbleType;
}

const Bubble: React.SFC<BubbleProps> = props => (
  <div
    className={classNames('c-bubble', {
      'c-bubble--right': props.type === BubbleType.Right,
      'c-bubble--wide': props.type === BubbleType.Wide
    })}
  >
    {props.children}
  </div>
);

export default Bubble;



// WEBPACK FOOTER //
// ./src/components/bubble/bubble.tsx